const TZ = "Asia/Riyadh";

const dtf = new Intl.DateTimeFormat("en-GB", {
  timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true,
});

const parts = (f, d) => Object.fromEntries(f.formatToParts(d).map((p) => [p.type, p.value]));

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const p = parts(dtf, new Date(iso));
  return `${p.day}/${p.month}/${p.year} ${p.hour.padStart(2, "0")}:${p.minute} ${p.dayPeriod.toUpperCase()}`;
};

export const fmtDate = (ymd) => {
  if (!ymd) return "—";
  const [y, m, d] = ymd.split("-");
  return `${d}/${m}/${y}`;
};

export const fmtMoney = (n) =>
  Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const riyadhToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: TZ }).format(new Date());

const clockFmt = new Intl.DateTimeFormat("en-GB", {
  timeZone: TZ, weekday: "short", day: "2-digit", month: "2-digit", year: "numeric",
  hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
});

export const riyadhClock = () => {
  const p = parts(clockFmt, new Date());
  return `${p.weekday} ${p.day}/${p.month}/${p.year} ${p.hour.padStart(2, "0")}:${p.minute}:${p.second} ${p.dayPeriod.toUpperCase()}`;
};

export const riyadhLongDate = () => {
  const p = parts(new Intl.DateTimeFormat("en-GB", { timeZone: TZ, weekday: "long", day: "2-digit", month: "2-digit", year: "numeric" }), new Date());
  return `${p.weekday}, ${p.day}/${p.month}/${p.year}`;
};

export const ROLE_LABEL = { super_admin: "Super Admin", staff: "Staff", auditor: "Auditor" };

export const fmtBytes = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

export const withinEditWindow = (iso) => Date.now() - new Date(iso).getTime() <= 24 * 3600 * 1000;
